import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { interiors } from '../../../../reducers/interiors/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import { getDropdownOptions } from '../enhance';

const mapStateToProps = combineSelectors({
  interiors,
});

const options = ({ interiors, availableOptions }) =>
  getDropdownOptions(interiors, availableOptions);

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['interiorFormPlaceHolder'] }),
  connect(mapStateToProps),
  addProps({ options }),
);
